import * as React from 'react';
import classnames from 'classnames';

import TileStandardContext from '../context/TileStandardContext';
import TileStandardCarouselItem from './item/TileStandardCarouselItem';
import TileStandardCarouselControl from './control/TileStandardCarouselControl';

import ContentListResultsContext from 'modules/lists-content/context/ContentListResultsContext';

import './tile-standard-carousel.scss';

import type { TileStandardCarouselType } from 'types';

type Props = {
  type: TileStandardCarouselType,
  className?: string,
  classNameItem?: string
};

const TileStandardCarousel = (
  {
    type = 'standard',
    className,
    classNameItem
  }: Props
): JSX.Element => {
  const content = React.useContext(TileStandardContext);

  const containerClasses = classnames('tile-standard-carousel', className, {
    [`tile-standard-carousel--type-${type}`]: Boolean(type)
  });

  return (
    <div className={containerClasses}>
      {
        content && (
          <React.Fragment>
            <ContentListResultsContext.Provider
              value={content.recentPosts}
            >
              {
                content.carouselItems.map((item, index) => (
                  <TileStandardCarouselItem
                    key={`tile-standard-carousel__item--${item.code}-${index}`}
                    type={type}
                    activeTab={content.activeTab}
                    items={content.recentPosts}
                    item={item}
                    index={index}
                    galleryModalIndexStart={content.galleryModalIndexStart}
                    isLoading={item.type === 'loading'}
                    classNameItem={classNameItem}
                    onLastPage={content.onGalleryLastPage}
                  />
                ))
              }
            </ContentListResultsContext.Provider>
            <TileStandardCarouselControl
              key="tile-standard-carousel__controls--prev"
              direction="prev"
              isDisabled={content.carouselIndex === 0}
            />
            <TileStandardCarouselControl
              key="tile-standard-carousel__controls--next"
              direction="next"
              skipTooltip={content.isLoading}
              isDisabled={!content.hasNextRecentPostsPage}
            />
          </React.Fragment>
        )
      }
    </div>
  );
};

export default TileStandardCarousel;
